export default "__VITE_ASSET__CJQdrc6l__"